(function () {
  const normalize = (t) => (t || "").toString().trim().toLowerCase();

  function getColorFromAlt(alt) {
    return normalize((alt || "").split("|")[0]);
  }

  function getCachedColorFromNode(node) {
    if (!node) return "";
    if (node.dataset && node.dataset.swcColor) return node.dataset.swcColor;

    const img = node.querySelector?.("img");
    const alt = img?.getAttribute("alt") || "";
    const color = getColorFromAlt(alt);

    if (node.dataset) node.dataset.swcColor = color;
    return color;
  }

  function findSections() {
    return document.querySelectorAll(
      "section[id^='MainProduct-'], section[id^='FeaturedProduct-'], .product"
    );
  }

  function getSelectedColor(section) {
    const variantSelects = section.querySelector("variant-selects");
    if (!variantSelects) return "";

    const selects = variantSelects.querySelectorAll("select");
    if (selects.length) {
      for (const sel of selects) {
        const name = sel.getAttribute("name") || "";
        if (name.includes("Color") || name.includes("Colour")) return normalize(sel.value);
      }
      return normalize(selects[0].value);
    }

    const fieldsets = variantSelects.querySelectorAll("fieldset");
    for (const fs of fieldsets) {
      const legendText = fs.querySelector("legend")?.textContent || "";
      if (/color|colour/i.test(legendText)) {
        const checked = fs.querySelector("input[type='radio']:checked");
        return normalize(checked?.value);
      }
    }

    const checkedAny = variantSelects.querySelector("input[type='radio']:checked");
    return normalize(checkedAny?.value);
  }

  function getAllMediaItems(section) {
    const items = Array.from(
      section.querySelectorAll(
        "media-gallery .product__media-item, media-gallery .product__media-list > li"
      )
    );
    // only items that truly have an image
    return items.filter((el) => el.querySelector("img"));
  }

  function getAllThumbs(section) {
    const gallery = section.querySelector("media-gallery");
    if (!gallery) return [];
    return Array.from(
      gallery.querySelectorAll(".thumbnail-list button, button.thumbnail, button[data-media-id]")
    ).filter((b) => b.querySelector("img"));
  }

  function getSlideWrapper(el) {
    return el?.closest?.(".slider__slide") || el;
  }

  function setVisible(el, isVisible) {
    const target = getSlideWrapper(el);
    if (!target) return;
    target.classList.toggle("swc-media-hidden", !isVisible);
    target.hidden = !isVisible;
    target.setAttribute("aria-hidden", (!isVisible).toString());
  }

  function toggleSingleMediaClass(section) {
    const items = Array.from(
      section.querySelectorAll(
        "media-gallery .product__media-item, media-gallery li[data-media-id], .product__media-item"
      )
    );
    const visible = items.filter(
      (el) => !getSlideWrapper(el).classList.contains("swc-media-hidden")
    );
    section.classList.toggle("swc-single-media", visible.length === 1);
  }

  // Important: refresh slider ONLY when color changes (not on every mutation)
  function refreshDawnSlider(section) {
    const sliderComponent =
      section.querySelector("media-gallery slider-component") ||
      section.querySelector("slider-component");
    if (!sliderComponent) return;

    if (typeof sliderComponent.resetPages === "function") sliderComponent.resetPages();
    if (typeof sliderComponent.initPages === "function") sliderComponent.initPages();
    if (typeof sliderComponent.update === "function") sliderComponent.update();

    window.dispatchEvent(new Event("resize"));
  }

  function applyFilter(section) {
    const color = getSelectedColor(section);
    if (!color) return;

    const mediaItems = getAllMediaItems(section);
    const thumbs = getAllThumbs(section);

    let matchCount = 0;

    // STRICT: only matching
    mediaItems.forEach((item) => {
      const itemColor = getCachedColorFromNode(item);
      const isMatch = itemColor === color;
      setVisible(item, isMatch);
      if (isMatch) matchCount++;
    });

    thumbs.forEach((btn) => {
      const itemColor = getCachedColorFromNode(btn);
      setVisible(btn, itemColor === color);
    });

    // fallback: nothing matches -> show ONLY active featured media
    if (matchCount === 0 || mediaItems.length === 0) {
      mediaItems.forEach((item) => setVisible(item, false));
      thumbs.forEach((btn) => setVisible(btn, false));

      const activeMediaItem =
        section.querySelector("media-gallery .product__media-item.is-active") ||
        section.querySelector("media-gallery .product__media-item[aria-current='true']") ||
        section.querySelector("media-gallery .product__media-item");

      if (activeMediaItem) setVisible(activeMediaItem, true);

      const activeThumb =
        section.querySelector(".thumbnail-list button[aria-current='true']") ||
        section.querySelector("button.thumbnail[aria-current='true']") ||
        section.querySelector(".thumbnail-list button") ||
        section.querySelector("button.thumbnail");

      if (activeThumb) setVisible(activeThumb, true);
    }

    toggleSingleMediaClass(section);
  }

  function waitForMainImage(section, cb) {
    const mainImg = section.querySelector("media-gallery .product__media img, .product__media img");
    if (mainImg && !mainImg.complete) {
      mainImg.addEventListener("load", cb, { once: true });
      mainImg.addEventListener("error", cb, { once: true });
    } else {
      cb();
    }
  }

  function initSection(section) {
    let rafPending = false;
    let lastColor = null;

    const runIfColorChanged = (alsoRefreshSlider) => {
      const current = getSelectedColor(section);
      if (!current) return;

      // Only re-filter when COLOR actually changes
      if (current === lastColor) return;

      lastColor = current;

      applyFilter(section);

      // only after change, refresh Dawn slider once
      if (alsoRefreshSlider) refreshDawnSlider(section);
    };

    const schedule = (alsoRefreshSlider = false) => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        runIfColorChanged(alsoRefreshSlider);
      });
    };

    // initial
    schedule(true);

    // on variant change
    section.addEventListener("variant:change", () => {
      waitForMainImage(section, () => schedule(true));
    });

    // fallback change handler
    const vs = section.querySelector("variant-selects");
    if (vs) {
      vs.addEventListener("change", () => {
        waitForMainImage(section, () => schedule(true));
      });
    }

    // re-render protection: DO NOT refresh slider here (keeps swipe smooth)
    const gallery = section.querySelector("media-gallery");
    if (gallery) {
      const obs = new MutationObserver(() => schedule(false));
      obs.observe(gallery, { childList: true, subtree: true });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    findSections().forEach(initSection);
  });
})();
